import { createContext, useContext } from "react";

const IsEditFormContext = createContext(false);

export const IsEditFormProvider = IsEditFormContext.Provider;

export const useIsEditForm = () => useContext(IsEditFormContext);
